module.exports = __webpack_public_path__ + "static/media/earning_campaign_icon.252da261.png";